import {IEnvironment} from './types'
import {InjectionToken} from '@angular/core'

export const HOME_PATH = 'home'
export const LOGIN_PATH = 'login'

export const ENVIRONMENT = new InjectionToken<IEnvironment>('environment')
